import { ChevronIcon } from "@/components/icon";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  TableCellWithTime,
} from "@/components/TableComponents";
import { Link } from "react-router";

const customerGlobalStrategy = [
  {
    title: <DefaultHeadColumns text="Address" />,
    dataIndex: "addressA",
    key: "addressA",
    className:
      "!border-b-8 !border-gray-border !first:border-none first:!py-0 !h-10 !before:hidden",
    render: (value: any) => {
      return (
        <DefaultTextColumn
          text={value?.locationId}
          key={value?.locationId + value?.id}
          className="capitalize  w-full truncate py-0 max-w-1/2 "
          labelClassName="capitalize"
        />
      );
    },
  },
  {
    title: <DefaultHeadColumns text="Quote ID" />,
    dataIndex: "quoteReqId",
    key: "quoteReqId",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",

    render: (value: any, record: any) => {
      if (value && record.source === "price") {
        return (
          <Link
            className="block text-primary py-4 "
            to={`/singleSiteQuoteResults/${value}`}
            key={[value, record.id].join(",")}
          >
            {value}
          </Link>
        );
      }
      return (
        <DefaultTextColumn
          text={value}
          key={[record.id, value].join(",")}
          className="py-4"
        />
      );
    },
  },
  // {
  //   title: <DefaultHeadColumns text="End Customer Name" />,
  //   dataIndex: "endCustomerName",
  //   key: "endCustomerName",
  //   render: (value: any) => {
  //     return <DefaultTextColumn text={value} key={value} className="py-0" />;
  //   },
  // },
  // {
  //   title: <DefaultHeadColumns text="Project Number" />,
  //   dataIndex: "customerProjectNumber",
  //   key: "customerProjectNumber",
  //   render: (value: any) => (
  //     <DefaultTextColumn text={value} key={value} className="py-0" />
  //   ),
  // },
  {
    title: <DefaultHeadColumns text="Quote Due Date" />,
    dataIndex: "dueDate",
    key: "dueDate",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",
    render: (value: any) => (
      <TableCellWithTime
        value={value}
        key={value}
        className="py-0"
        format="DD-MM-YYYY"
      />
    ),
  },
  // {
  //   title: <DefaultHeadColumns text="RFS Date" />,
  //   dataIndex: "RFSdate",
  //   key: "RFSdate",
  //   render: (value: any) => (
  //     <TableCellWithTime
  //       value={value}
  //       key={value}
  //       className="py-0"
  //       format="DD-MM-YYYY"
  //     />
  //   ),
  // },
  {
    title: <DefaultHeadColumns text="Quote Request Date" />,
    dataIndex: "createdAt",
    key: "createdAt",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden",

    render: (value: any) => (
      <TableCellWithTime
        value={value}
        key={value}
        className="py-0"
        format="DD-MM-YYYY"
      />
    ),
  },

  {
    title: "",
    dataIndex: "quoteReqId",
    key: "expandable",
    className:
      "!border-b-8 !border-gray-border !first:border-none !py-0 !h-10 !before:hidden ",
    render: () => (
      <div className="-rotate-90 flex items-center justify-center">
        <ChevronIcon />
      </div>
    ),
  },
];
export default customerGlobalStrategy;
